import PropTypes from 'prop-types';
import microSimService from '../../services/microSimService';
import MicroSimReport from './MicroSimReport';

/**
 * Participant Details → "Micro sims" tab (staff only). One visual report per micro
 * simulation this participant finished in the session, newest first, each with its PDF.
 */
const MicroSimParticipantTab = ({ reports }) => (
  <div className="grid gap-4 lg:grid-cols-2">
    {reports.map(({ launchId, report }) => (
      <div key={report.runId} className="rounded-2xl border border-neutral-200 bg-neutral-50/60 p-4">
        <MicroSimReport
          compact
          report={report}
          onDownloadPdf={() => microSimService.downloadPersonPdf(launchId, report.runId, report.me.slot)}
        />
      </div>
    ))}
  </div>
);

MicroSimParticipantTab.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.shape({
    launchId: PropTypes.string.isRequired,
    report: PropTypes.object.isRequired,
  })).isRequired,
};

export default MicroSimParticipantTab;
